export interface BaseApiSendMessageVars {
  message: string
}

export interface BaseApiSendMessageResponseFeedbackVars {
  promptId: string
  reaction: number
}

export type BaseApiAuthor = 'user' | 'assistant'

export type BaseApiMessage = {
  role: BaseApiAuthor
  content: string
  citations?: null | number[]
  hideReactions?: boolean
  id: string
  liked?: boolean
  disliked?: boolean
}

export interface BaseApiCitation {
  id: number
  title: string
  description: string
  image: string | null
  url: string
}

export enum FeedbackApiResponseReaction {
  Like = 2,
  Dislike = 3
}
